import { render } from "./StatisticContainer.vue?vue&type=template&id=6d6e4b22&scoped=true"
import script from "./StatisticContainer.vue?vue&type=script&lang=js"
export * from "./StatisticContainer.vue?vue&type=script&lang=js"

import "./StatisticContainer.vue?vue&type=style&index=0&id=6d6e4b22&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6e4b22"]])

export default __exports__